{
  "name": "@payment-kit-js/vanilla",
  "version": "0.5.20",
  "main": "./dist/index.mjs",
  "types": "./dist/index.d.mts",
  "module": "./dist/index.mjs",
  "exports": {
    ".": "./dist/index.mjs",
    "./payment-methods/affirm": "./dist/payment-methods/affirm.mjs",
    "./payment-methods/afterpay": "./dist/payment-methods/afterpay.mjs",
    "./payment-methods/airwallex-apple-pay-adapter": "./dist/payment-methods/airwallex-apple-pay-adapter.mjs",
    "./payment-methods/airwallex-google-pay-adapter": "./dist/payment-methods/airwallex-google-pay-adapter.mjs",
    "./payment-methods/apple-pay": "./dist/payment-methods/apple-pay.mjs",
    "./payment-methods/bnpl-shared": "./dist/payment-methods/bnpl-shared.mjs",
    "./payment-methods/card": "./dist/payment-methods/card.mjs",
    "./payment-methods/google-pay": "./dist/payment-methods/google-pay.mjs",
    "./payment-methods/klarna": "./dist/payment-methods/klarna.mjs",
    "./payment-methods/next-action-handlers": "./dist/payment-methods/next-action-handlers.mjs",
    "./payment-methods/paypal": "./dist/payment-methods/paypal.mjs",
    "./payment-methods/stripe-apple-pay-adapter": "./dist/payment-methods/stripe-apple-pay-adapter.mjs",
    "./payment-methods/stripe-google-pay-adapter": "./dist/payment-methods/stripe-google-pay-adapter.mjs",
    "./payment-methods/vgs-collect-loader": "./dist/payment-methods/vgs-collect-loader.mjs",
    "./penpal/connect-card": "./dist/penpal/connect-card.mjs",
    "./penpal/connect-tunnel-x": "./dist/penpal/connect-tunnel-x.mjs",
    "./package.json": "./package.json"
  },
  "license": "MIT",
  "description": "Vanilla package for PaymentKit",
  "files": [
    "dist",
    "dist/cdn"
  ],
  "scripts": {
    "dev": "yarn tsdown --watch ./src",
    "build:npm": "yarn tsdown",
    "build:cdn": "node build-cdn.mjs",
    "build": "yarn build:npm && yarn build:cdn"
  },
  "packageManager": "yarn@4.10.3",
  "dependencies": {
    "nanoid": "^5.0.7",
    "penpal": "^7.0.4",
    "posthog-js": "^1.196.0",
    "valibot": "^1.1.0"
  },
  "devDependencies": {
    "@pkg/sdk": "workspace:*",
    "@pkg/tsconfig": "workspace:*",
    "@stripe/stripe-js": "^8.6.1",
    "@types/applepayjs": "^14.0.9",
    "esbuild": "^0.24.2",
    "tsdown": "^0.15.10",
    "typescript": "^5.9.3"
  },
  "stableVersion": "0.5.20"
}
